import AddEditView from './containers/AddEditView';
import React from 'react';

export default AddEditView;

export {uiDataAddEditView, serverDataAddEditView} from './reducers/AddEditView';